(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arden-choosing-guide"] && !Shopify.designMode) return;
  try {
    
  class ArdenFitFinder extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.form = this.querySelector('[data-fit-form]');
      this.steps = Array.from(this.querySelectorAll('[data-fit-step]'));
      this.progress = Array.from(this.querySelectorAll('[data-fit-progress]'));
      this.result = this.querySelector('[data-fit-result]');
      this.resultCard = this.querySelector('[data-fit-result-card]');
      this.preview = this.closest('.ab-fit').querySelector('[data-fit-preview]');
      this.currentStep = 0;
      this.form.addEventListener('change', () => this.updatePreview());
      this.querySelectorAll('[data-fit-next]').forEach((button) => button.addEventListener('click', () => this.goTo(this.currentStep + 1)));
      this.querySelectorAll('[data-fit-back]').forEach((button) => button.addEventListener('click', () => this.goTo(this.currentStep - 1)));
      this.querySelector('[data-fit-restart]').addEventListener('click', () => this.restart());
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.showResult();
      });
      this.updatePreview();
    }

    getSelection() {
      return Object.fromEntries(new FormData(this.form).entries());
    }

    transition(update) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (document.startViewTransition && !reduceMotion) {
        document.startViewTransition(update);
      } else {
        update();
      }
    }

    goTo(index) {
      const nextIndex = Math.max(0, Math.min(index, this.steps.length - 1));
      this.transition(() => {
        this.currentStep = nextIndex;
        this.result.hidden = true;
        this.form.hidden = false;
        this.steps.forEach((step, stepIndex) => {
          step.hidden = stepIndex !== nextIndex;
        });
        this.progress.forEach((item, itemIndex) => {
          if (itemIndex === nextIndex) item.setAttribute('aria-current', 'step');
          else item.removeAttribute('aria-current');
          item.dataset.complete = itemIndex < nextIndex ? 'true' : 'false';
        });
      });
      this.steps[nextIndex].querySelector('legend').focus({ preventScroll: true });
    }

    updatePreview() {
      const selection = this.getSelection();
      const labels = {
        cabinet: ['Cabinets & counters', 'Turn prep space into a brighter workspace.'],
        closet: ['Closets & wardrobes', 'Find what you need without flooding the room.'],
        pantry: ['Pantries & storage', 'Bring hidden shelves into view.'],
        path: ['Hallways & stairs', 'Make late-night movement feel more considered.'],
        shelf: ['Desks & shelves', 'Add focused light without adding clutter.']
      };
      const modes = { motion: 'Motion-ready', task: 'Direct control', flex: 'Flexible glow' };
      const space = selection.space || 'cabinet';
      const mode = selection.mode || 'motion';
      this.preview.dataset.scene = space;
      this.preview.dataset.mode = mode;
      this.preview.querySelector('[data-fit-preview-label]').textContent = labels[space][0];
      this.preview.querySelector('[data-fit-preview-title]').textContent = labels[space][1];
      this.preview.querySelector('[data-fit-status]').textContent = modes[mode];
    }

    getMatch(selection) {
      if (selection.space === 'closet') return 'wardrobe';
      if (selection.space === 'pantry') return 'pantry';
      if (selection.space === 'path') return 'path';
      if (selection.mode === 'motion') return 'motion';
      return 'task';
    }

    showResult() {
      const selection = this.getSelection();
      const match = this.getMatch(selection);
      const template = this.querySelector(`[data-fit-template="${match}"]`);
      const quantity = {
        compact: 'Start with one light for this focused zone.',
        standard: 'Compare a longer option or a two-light set for more even coverage.',
        wide: 'A three-light plan can spread the glow across this wider area.'
      };
      this.transition(() => {
        this.form.hidden = true;
        this.result.hidden = false;
        this.resultCard.replaceChildren(template.content.cloneNode(true));
        this.querySelector('[data-fit-quantity]').textContent = quantity[selection.coverage] || quantity.compact;
        this.progress.forEach((item) => {
          item.removeAttribute('aria-current');
          item.dataset.complete = 'true';
        });
      });
      this.result.focus({ preventScroll: true });
    }

    restart() {
      this.form.reset();
      this.currentStep = 0;
      this.updatePreview();
      this.goTo(0);
    }
  }

  if (!customElements.get('arden-fit-finder')) {
    customElements.define('arden-fit-finder', ArdenFitFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arden-curated-collection"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('arden-room-filter')){customElements.define('arden-room-filter',class extends HTMLElement{connectedCallback(){if(this.bound)return;this.bound=true;this.addEventListener('click',e=>{const button=e.target.closest('button[data-room]');if(!button)return;this.querySelectorAll('button[data-room]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));this.querySelectorAll('[data-product-room]').forEach(card=>{card.hidden=button.dataset.room!=='all'&&!card.dataset.productRoom.split(' ').includes(button.dataset.room)});});}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
